import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Box } from '@components/common';
import ScheduleBoard from '@components/ScheduleBoard';
import { CalendarViewFullItem } from '@components/Calendar';
import ScheduleActions, { ScheduleSelectors } from '@redux/ScheduleRedux';
import { AppSelectors } from '@redux/AppRedux';
import useDetectSize from '@hooks/useDetectSize';

function TimeframeBoardView(props) {
  const { selectedItems, numOfRows, serviceTypeData } = props;

  const isMobile = useDetectSize();
  const specialItems = selectedItems.reduce((acc, item) => {
    const { row, col, serviceType, addons, serviceDate } = item;

    const { timeframe, timeframeTitle } = serviceDate;
    if (!acc[`row_${row}`]) {
      acc[`row_${row}`] = {};
    }
    acc[`row_${row}`][`col_${col}`] = {
      row,
      col,
      serviceType,
      addons,
      timeframe,
      timeframeTitle
    };
    return acc;
  }, {});

  const filledExtractor = () => {
    return false;
  };
  const disabledExtractor = (row, col, specialItem) => !specialItem;

  const renderItem = (specialItem, disabled) => {
    const { serviceType, addons, timeframe, timeframeTitle } = specialItem;

    const serviceTypeDetail = serviceTypeData[serviceType];
    const { fullTitle } = serviceTypeDetail;
    const iconFill = disabled ? 'darkGray' : undefined;
    const extraItems = addons
      ? addons.map(addon => ({
          icon: addon,
          name: addon,
          title: addon
        }))
      : undefined;

    const iconProps = isMobile
      ? { width: 24, height: 24 }
      : { width: 16, height: 16 };

    return (
      <CalendarViewFullItem
        iconFill={iconFill}
        serviceTypeIcon={serviceType}
        timeframeIcon={timeframe}
        timeframeTitle={timeframeTitle}
        fullTitle={fullTitle}
        extraItems={isMobile ? undefined : extraItems}
        iconProps={iconProps}
        disabled={disabled}
      />
    );
  };
  return (
    <Box display="flex" flexDirection="row">
      <ScheduleBoard
        numOfRows={numOfRows}
        specialItems={specialItems}
        renderSpecialItem={renderItem}
        disabledExtractor={disabledExtractor}
        filledExtractor={filledExtractor}
      />
    </Box>
  );
}

TimeframeBoardView.propTypes = {
  selectedItems: PropTypes.array,
  numOfRows: PropTypes.number,
  moveItem: PropTypes.func,
  removeItem: PropTypes.func,
  serviceTypeData: PropTypes.object
};

const mapStatesToProps = state => ({
  selectedItems: ScheduleSelectors.selectScheduledItems(state),
  numOfRows: ScheduleSelectors.selectNumOfRows(state),
  serviceTypeData: AppSelectors.selectServiceTypeData(state)
});

const mapDispatchToProps = dispatch => ({
  removeItem: item => dispatch(ScheduleActions.detachAddonToItem(item)),
  moveItem: (item, newItem) =>
    dispatch(ScheduleActions.moveAddonToItem(item, newItem))
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(TimeframeBoardView);
